import { SearchOutlined } from '@ant-design/icons';
import { StyledSearch } from './style';
import { FC } from 'react';

interface Props {
  placeholder?: string;
  onSearch: Function;
  testId?: string;
}

const SearchBar: FC<Props> = props => {
  const { onSearch, placeholder, testId } = props;

  return (
    <StyledSearch
      data-testid={testId}
      placeholder={placeholder}
      allowClear
      onSearch={keyword => onSearch(keyword)}
      bordered={false}
      prefix={<SearchOutlined />}
    />
  );
};

export default SearchBar;
